import { render, staticRenderFns } from "./footer-site.vue?vue&type=template&id=b79c5450&scoped=true"
import script from "./footer-site.vue?vue&type=script&lang=js"
export * from "./footer-site.vue?vue&type=script&lang=js"
import style0 from "./footer-site.vue?vue&type=style&index=0&id=b79c5450&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79c5450",
  null
  
)

export default component.exports